// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import DraftRoundSvg from '@rsuite/icon-font/lib/status/DraftRound';
var DraftRound = createSvgIcon({
  as: DraftRoundSvg,
  ariaLabel: 'draft round',
  category: 'status',
  displayName: 'DraftRound'
});
export default DraftRound;